import { render, staticRenderFns } from "./PostSender.vue?vue&type=template&id=e93f7582"
import script from "./PostSender.vue?vue&type=script&lang=js"
export * from "./PostSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports